import React, { forwardRef } from 'react'
import HCaptcha from '@hcaptcha/react-hcaptcha'
import AppStore from '@v4/store/appStore'

const Captcha = forwardRef((props, ref) => {
	const isBuilderMode = AppStore.useStoreState(state => state.general.isBuilderMode)
	const siteKey = import.meta.env.VITE_CAPTCHA_SITE_KEY || null

	return !isBuilderMode && siteKey && <HCaptcha ref={ref} size="invisible" {...props} sitekey={siteKey} />
})

export default Captcha
